export default {
    noticeList: [],
    noticeListCount: 0,
    notice: {},
}